import { createRankService } from "../rank-service/rank-service";
import { createRankStars } from "../rank-stars/rank-stars";
import "./trusting-info.css";

export const createTrustingInfo = () => {
  createRankStars();
  createRankService();
};
